import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './warpedShadow.scss';

// Note: You may have to set z-index: 1 on your wrapped component

export default function WarpedShadow({ className, children, enabled, size }) {
	return enabled ? (
		<div className={classnames('ph-warped-shadow', size, className)}>
			{children}
		</div>
	) : children;
}

WarpedShadow.propTypes = {
	children: PropTypes.node,
	enabled: PropTypes.bool,
	size: PropTypes.oneOf(['medium']),
	className: PropTypes.string
};

WarpedShadow.defaultProps = {
	enabled: true,
	size: 'medium'
};
